import { render, staticRenderFns } from "./UncompletedList.vue?vue&type=template&id=2564c1ce"
import script from "./UncompletedList.vue?vue&type=script&lang=js"
export * from "./UncompletedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports